"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getTypedTransaction = exports.getTransactionData = exports.toTransactionRaw = exports.fromTransactionRaw = exports.formatTransaction = exports.DEFAULT_GAS_LIMIT = void 0;
var ethers_1 = require("ethers");
var bignumber_js_1 = require("bignumber.js");
var currencies_1 = require("../../currencies");
var account_1 = require("../../account");
var erc20_abi_json_1 = __importDefault(require("./abis/erc20.abi.json"));
var common_1 = require("../../transaction/common");
exports.DEFAULT_GAS_LIMIT = new bignumber_js_1.BigNumber(21000);
/**
 * Format the transaction for the CLI
 */
var formatTransaction = function (_a, account) {
    var mode = _a.mode, amount = _a.amount, recipient = _a.recipient, useAllAmount = _a.useAllAmount;
    return "\n".concat(mode.toUpperCase(), " ").concat(useAllAmount
        ? "MAX"
        : amount.isZero()
            ? ""
            : " " +
                (0, currencies_1.formatCurrencyUnit)((0, account_1.getAccountUnit)(account), amount, {
                    showCode: true,
                    disableRounding: true
                })).concat(recipient ? "\nTO ".concat(recipient) : "");
};
exports.formatTransaction = formatTransaction;
/**
 * Serializer raw to transaction
 */
var fromTransactionRaw = function (rawTx) {
    var common = (0, common_1.fromTransactionCommonRaw)(rawTx);
    var tx = __assign(__assign({}, common), { family: rawTx.family, mode: rawTx.mode, chainId: rawTx.chainId, nonce: rawTx.nonce, gasLimit: new bignumber_js_1.BigNumber(rawTx.gasLimit), feesStrategy: rawTx.feesStrategy, type: Number(rawTx.type) });
    if (rawTx.data) {
        tx.data = Buffer.from(rawTx.data, "hex");
    }
    if (rawTx.gasPrice) {
        tx.gasPrice = new bignumber_js_1.BigNumber(rawTx.gasPrice);
    }
    if (rawTx.maxFeePerGas) {
        tx.maxFeePerGas = new bignumber_js_1.BigNumber(rawTx.maxFeePerGas);
    }
    if (rawTx.maxPriorityFeePerGas) {
        tx.maxPriorityFeePerGas = new bignumber_js_1.BigNumber(rawTx.maxPriorityFeePerGas);
    }
    return tx;
};
exports.fromTransactionRaw = fromTransactionRaw;
/**
 * Serializer transaction to raw
 */
var toTransactionRaw = function (tx) {
    var common = (0, common_1.toTransactionCommonRaw)(tx);
    var txRaw = __assign(__assign({}, common), { family: tx.family, mode: tx.mode, chainId: tx.chainId, nonce: tx.nonce, gasLimit: tx.gasLimit.toFixed(), feesStrategy: tx.feesStrategy, type: tx.type });
    if (tx.data) {
        txRaw.data = Buffer.from(tx.data).toString("hex");
    }
    if (tx.gasPrice) {
        txRaw.gasPrice = tx.gasPrice.toFixed();
    }
    if (tx.maxFeePerGas) {
        txRaw.maxFeePerGas = tx.maxFeePerGas.toFixed();
    }
    if (tx.maxPriorityFeePerGas) {
        txRaw.maxPriorityFeePerGas = tx.maxPriorityFeePerGas.toFixed();
    }
    return txRaw;
};
exports.toTransactionRaw = toTransactionRaw;
/**
 * Returns the data necessary to execute smart contracts.
 * As of now, only used to create ERC20 transfers' data
 */
var getTransactionData = function (transaction) {
    var contract = new ethers_1.ethers.utils.Interface(erc20_abi_json_1["default"]);
    var data = contract.encodeFunctionData("transfer", [
        transaction.recipient,
        transaction.amount.toFixed(),
    ]);
    return data ? Buffer.from(data.slice(2), "hex") : undefined;
};
exports.getTransactionData = getTransactionData;
/**
 * Returns a transaction with the correct type and entries depending
 * on the network compatiblity.
 */
var getTypedTransaction = function (transaction, feeData) {
    // If the blockchain is supporting EIP-1559, use maxFeePerGas & maxPriorityFeePerGas
    if (feeData.maxFeePerGas && feeData.maxPriorityFeePerGas) {
        delete transaction.gasPrice;
        return __assign(__assign({}, transaction), { maxFeePerGas: feeData.maxFeePerGas, maxPriorityFeePerGas: feeData.maxPriorityFeePerGas, type: 2 });
    }
    // Else just use a legacy transaction
    delete transaction.maxFeePerGas;
    delete transaction.maxPriorityFeePerGas;
    return __assign(__assign({}, transaction), { gasPrice: feeData.gasPrice || new bignumber_js_1.BigNumber(0), type: 0 });
};
exports.getTypedTransaction = getTypedTransaction;
exports["default"] = {
    formatTransaction: exports.formatTransaction,
    fromTransactionRaw: exports.fromTransactionRaw,
    toTransactionRaw: exports.toTransactionRaw,
    toTransactionStatusRaw: common_1.toTransactionStatusRawCommon,
    formatTransactionStatus: common_1.formatTransactionStatusCommon,
    fromTransactionStatusRaw: common_1.fromTransactionStatusRawCommon
};
//# sourceMappingURL=transaction.js.map